import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, object=auth
  const [token, setToken] = useState(() => localStorage.getItem("yk_token") || null);

  const authHeaders = useCallback(
    () => (token ? { Authorization: `Bearer ${token}` } : {}),
    [token]
  );

  const fetchMe = useCallback(async () => {
    if (!token) { setUser(false); return; }
    try {
      const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(res.data.user);
    } catch (e) {
      localStorage.removeItem("yk_token"); setToken(null); setUser(false);
    }
  }, [token]);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const persist = (userObj, t) => {
    localStorage.setItem("yk_token", t);
    setToken(t); setUser(userObj);
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    persist(res.data.user, res.data.access_token);
    return res.data.user;
  };

  const signupBuyer = async (payload) => {
    const res = await axios.post(`${API}/auth/signup/buyer`, payload);
    persist(res.data.user, res.data.access_token);
    return res.data.user;
  };

  const signupBusiness = async (payload) => {
    const res = await axios.post(`${API}/auth/signup/business`, payload);
    persist(res.data.user, res.data.access_token);
    return res.data.user;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch (e) { /* ignore */ }
    localStorage.removeItem("yk_token"); setToken(null); setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, authHeaders, login, signupBuyer, signupBusiness, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
